import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { SiteApiService } from 'src/app/api/site/siteApiService';
import { SiteSearchQuery } from 'src/app/api/site/siteSearchQuery';
import { SiteSearchResult } from 'src/app/api/site/siteSearchResult';
import { SearchStateService } from 'src/app/services/search-state/search-state.service';
import { Const } from 'src/app/const';

@Component({
  selector: 'site-search',
  templateUrl: './site-search.component.html',
  styleUrl: './site-search.component.css',
  host: { 'class': 'asset-search' },
  standalone: false
})
export class SiteSearchComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('loadingTrigger') loadingTrigger!: ElementRef;
  private observer: IntersectionObserver | null = null;
  loading: boolean = false;
  moreDataAvailable: boolean = false;
  siteSearchParams: SiteSearchQuery = new SiteSearchQuery();
  sites: SiteSearchResult[] | null = null;

  constructor(
    private siteApiService: SiteApiService,
    private searchStateService: SearchStateService
  ) {
    this.siteSearchParams.start = 0;
    this.siteSearchParams.limit = Const.SEARCH_QUERY_LIMIT;
  }

  ngOnInit(): void {
    const savedState = this.searchStateService.getSiteSearchState();
    if (savedState) {
      this.siteSearchParams = savedState;
      this.onSearchSites();
    }
    this.initializeIntersectionObserver();
  }

  private initializeIntersectionObserver(): void {
    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !this.loading && this.moreDataAvailable) {
          this.loadMoreSites();
        }
      },
      { threshold: 0.5 }
    );
  }

  ngAfterViewInit(): void {
    if (!this.loadingTrigger) {
      console.warn('Loading trigger element not found in template');
      return;
    }

    if (this.loadingTrigger && this.observer) {
      this.observer.observe(this.loadingTrigger.nativeElement);
    }
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  onSearchSites(): void {
    this.loading = true;
    this.sites = null;
    this.siteSearchParams.start = 0;

    this.searchStateService.saveSearchState(this.siteSearchParams);
    this.siteApiService.searchSites(this.siteSearchParams)
      .subscribe(sites => this.handleSearchResults(sites));
  }

  private handleSearchResults(sites: SiteSearchResult[]) {
    this.loading = false;
    this.sites = sites;
    this.siteSearchParams.start = sites.length > 0 ? sites[sites.length - 1].mibId : undefined;
    this.moreDataAvailable = sites.length == Const.SEARCH_QUERY_LIMIT;
  }

  loadMoreSites(): void {
    this.loading = true;

    this.siteApiService.searchSites(this.siteSearchParams)
      .subscribe(sites => this.handleLoadMoreResults(sites));
  }

  private handleLoadMoreResults(sites: SiteSearchResult[]) {
    this.loading = false;
    this.sites = this.sites!.concat(sites);
    this.siteSearchParams.start = sites.length > 0 ? sites[sites.length - 1].mibId : undefined;
    this.moreDataAvailable = sites.length == Const.SEARCH_QUERY_LIMIT;
  }
}
